import $ from 'jquery';
import bootstrap from 'bootstrap';
window.$ = $;
window.jQuery = $;


$(document).ready(function(){

});
